<template>
  <div class="main-body">
    <div class="container-fluid">
      <h3 class="text-black">{{ t("CL_OPT_OUT.HEADER") }}</h3>
      <h6
        class="mt-3 text-black"
        style="font-weight: normal"
        v-html="t('CL_OPT_OUT.DESCRIPTION')"
      ></h6>
      <hr />
      <section>
        <div class="d-flex my-0">
          <img
            :src="useAsset('img/credit-line/checkmark.svg')"
            alt="checkmark"
          />
          <p v-html="t('CL_OPT_OUT.BENEFIT_1')" class="ms-3 mb-0"></p>
        </div>
        <hr />
        <div class="d-flex">
          <img
            :src="useAsset('img/credit-line/checkmark.svg')"
            alt="checkmark"
          />
          <p v-html="t('CL_OPT_OUT.BENEFIT_2')" class="ms-3 mb-0"></p>
        </div>
      </section>
      <hr />
      <section id="option-group">
        <div
          v-for="(option, index) in reasonOptions"
          class="opt-out-option"
          :class="selectedReason === option && 'active'"
          v-bind:key="index"
        >
          <input
            type="radio"
            name="reason"
            :id="`r${index + 1}`"
            v-model="selectedReason"
            :value="option"
          />
          <label :for="`r${index + 1}`">{{ option }}</label>
        </div>
      </section>
      <div
        class="w-100 px-4 position-absolute"
        style="bottom: 3%; left: 0; right: 0"
      >
        <Button
          id="btn-submit"
          class="fw-bolder"
          @click="sendSurvey"
          :disabled="!selectedReason"
        >
          {{ t("CL_OPT_OUT.SUBMIT") }}
        </Button>
      </div>
    </div>
    <div v-if="fetching" class="loading-overlay">
      <i class="fa fa-spin fa-spinner" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import Button from "@/apps/credit-line/components/Button.vue";
import logAnalyticsEvent from "@/apps/credit-line/services/google-analytics-events.service";
import AnalyticEvents from "@/shared-helpers/google-analytics-events.helper";
import { Service } from "@/apps/credit-line/services/network.service";
import { AuthenticationHelper } from "@/apps/credit-line/helpers/authentication.helper";
import { ErrorHandler } from "@/apps/credit-line/helpers/errorHandlerWithLogger.helper";
import { AndroidInterface } from "@/apps/credit-line/services/android.service";
declare const Android: AndroidInterface;

export default defineComponent({
  name: "OptOut",
  components: { Button },
  setup() {
    const { t } = useI18n();
    const CreditLineService = new Service();
    const selectedReason = ref<string | null>();
    const fetching = ref<boolean>(false);

    const reasonOptions = [
      t("CL_OPT_OUT.REASON_1"),
      t("CL_OPT_OUT.REASON_2"),
      t("CL_OPT_OUT.REASON_3"),
      t("CL_OPT_OUT.REASON_4"),
      t("CL_OPT_OUT.REASON_5"),
    ];

    onMounted(async () => {
      logAnalyticsEvent(
        AnalyticEvents.CreditLine.OnBoardingOptOut,
        "CL_Opt_Out"
      );
    });

    const sendSurvey = async () => {
      fetching.value = true;
      try {
        logAnalyticsEvent(
          AnalyticEvents.CreditLine.OnBoardingOptOutReason,
          "CL_Opt_Out",
          `Reason: ${selectedReason.value}`
        );
        await CreditLineService.saveOptOutSurvey({
          deviceTag: AuthenticationHelper.getDeviceTag(),
        });
      } catch (error) {
        ErrorHandler.handleNetworkErrorAndLog(error);
      }
      fetching.value = false;
      Android.creditOfferRejected();
    };

    return {
      t,
      fetching,
      reasonOptions,
      selectedReason,
      useAsset,
      sendSurvey,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

img {
  height: 24px;
  width: 24px;
}

section p {
  color: black;
}

hr {
  margin: 5% 0;
}

#option-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.opt-out-option {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
  border-radius: 10px;
  border: 1px solid #eee;
  background: var(--main-white, #fff);
}

.active {
  border-radius: 10px !important;
  border: 1px solid var(--borders-green-300, #bfdac7) !important;
  background: var(--main-primary-300, #e4f4eb) !important;
}

.opt-out-option {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
  border-radius: 10px;
  border: 1px solid #eee;
  background: var(--main-white, #fff);
}

.opt-out-option input {
  margin: 12px 0 12px 12px;
  accent-color: #2c7040 !important;
}

.opt-out-option label {
  width: 100%;
  margin: 12px 0 12px 0;
}

#btn-submit {
  border-radius: 10px;
  background: var(--main-primary-500, #2c7040);
  height: 44px;
  padding: 10px 24px;
  margin: 0 auto;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $pj-color-green;
  font-size: 40px;
  background-color: rgba(150, 150, 150, 0.4);
  width: 100vw;
  height: 100vh;
  z-index: 1000;
}
</style>
